import React from 'react';
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TDPTableSelectRedux from '../TDP/TDPTableSelectRedux';
import TurmaDisciplinaProfessorProfileRedux from '../TDP/TurmaDisciplinaProfessorProfileRedux';
import { useSelector } from 'react-redux';
import NotaBimestreTipoTable from '../NotaBimestreTipo/NotaBimestreTipoTable';
import NotaBimestreTable from './NotaBimestreTable';
import Grid from '@mui/material/Grid';
import NotaBimestreForm from './NotaBimestreForm';
import ConceitoAlunoTable from '../ConceitoAluno/ConceitoAlunoTable';
import ConceitoAlunoForm from '../ConceitoAluno/ConceitoAlunoForm';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    table: {
        paddingTop: '20px;',
        marginBottom: '20px'
    },
    title: {
        marginBottom: '20px'
    },
});

export default function NotaBimestreContainer() {
    const classes = useStyles();
    const tdp = useSelector(state => state.tdp);
    const notaBimestreTipo = useSelector(state => state.notaBimestreTipo);

    return (
        <div>
            <CssBaseline />
            <Container className={classes.paper} component={Paper}>
                <Grid container justifyContent="space-between">
                    <Grid size={3}>
                        {tdp ?
                            <Typography className={classes.title} variant="h6">
                                {tdp.eEletiva || tdp.eProjeto ? 'Conceito' : 'Nota Bimestre'}
                            </Typography> : ''}

                    </Grid>

                </Grid>
                {tdp ?
                    <>
                        <TurmaDisciplinaProfessorProfileRedux />
                        {tdp.eEletiva || tdp.eProjeto ?
                            <>
                                <Grid container spacing={3}>
                                    <Grid size={6}>
                                        <ConceitoAlunoTable />
                                    </Grid>
                                    <Grid size={6}>
                                        <ConceitoAlunoForm />
                                    </Grid>
                                </Grid>
                            </>
                            :
                            <Grid container spacing={3}>
                                <Grid size={6}>
                                    {notaBimestreTipo ? <NotaBimestreTable /> : <NotaBimestreTipoTable />}
                                </Grid>
                                <Grid size={6}>
                                    {notaBimestreTipo ? <NotaBimestreForm /> : ''}
                                </Grid>
                            </Grid>
                        }

                    </> :
                    <TDPTableSelectRedux />
                }
            </Container>
        </div>
    );
}